// removed by extract-text-webpack-plugin
module.exports = {"noticeRibbon":"noticeRibbon__3CsU_","noticeRibbonTab":"noticeRibbonTab__2AqSz","noticeRibbonTitle":"noticeRibbonTitle__1NrcE","badge":"badge__3TQEk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/noticeRibbon/style.scss
// module id = 251
// module chunks = 0